import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = { class: "text-dark order-2 order-md-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold me-1" }, "2022©", -1)
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Swift")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#333333"} }, "Identity", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "menu menu-gray-600 menu-hover-primary fw-bold order-1" }
const _hoisted_9 = { class: "menu-item" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "menu-item" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "menu-item" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "menu-item" }
const _hoisted_16 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        'container-xxl': !_ctx.footerWidthFluid,
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("a", {
          href: _ctx.mrbUrl,
          target: "_blank",
          class: "text-gray-800 text-hover-primary"
        }, _hoisted_7, 8, _hoisted_4)
      ]),
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", _hoisted_9, [
          _createElementVNode("a", {
            href: _ctx.mrbUrlAbout,
            target: "_blank",
            class: "menu-link px-2"
          }, "About", 8, _hoisted_10)
        ]),
        _createElementVNode("li", _hoisted_11, [
          _createElementVNode("a", {
            href: _ctx.mrbUrlContact,
            target: "_blank",
            class: "menu-link px-2"
          }, "Contact Us", 8, _hoisted_12)
        ]),
        _createElementVNode("li", _hoisted_13, [
          _createElementVNode("a", {
            href: _ctx.mrbUrlTerms,
            target: "_blank",
            class: "menu-link px-2"
          }, "Terms & Conditions", 8, _hoisted_14)
        ]),
        _createElementVNode("li", _hoisted_15, [
          _createElementVNode("a", {
            href: _ctx.mrbUrlPrivacy,
            target: "_blank",
            class: "menu-link px-2"
          }, "Privacy Policy", 8, _hoisted_16)
        ])
      ])
    ], 2)
  ]))
}